import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import {
  getUnderlyingLiveFeed,
  getUnderlyingLiveFeedClosePrices,
} from '../../../../stores/underlying-live-feed/getters';
import PlusMinusColoredValue from '../../../PlusMinusColoredValue';
import { getSymbolBasedOnvalue } from '../../../../helpers/get-symbol-based-on-value';

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: 11,
    fontWeight: 600,
    lineHeight: '16.9px',
    display: 'inline-flex',
    marginLeft: 5,

    [theme.breakpoints.up('md')]: {
      fontSize: 12,
    },
  },
}));

function calculatePriceGap(ltpPrice, closePrice) {
  if (!ltpPrice && ltpPrice !== 0) {
    return 0;
  }

  if (!closePrice) {
    return 0;
  }

  const diffrence = ltpPrice - closePrice;

  return diffrence;
}

const PriceDiffrenceBetween = ({ symbol }) => {
  const classes = useStyles();
  const ltp = useSelector((state) => {
    const value = getUnderlyingLiveFeed(state);

    const { ltp } = value[symbol] ? value[symbol] : {};

    return ltp;
  });

  const closePrice = useSelector((state) => {
    const value = getUnderlyingLiveFeedClosePrices(state);

    const { ltp } = value[symbol] ? value[symbol] : {};

    return ltp;
  });

  const diffrence = calculatePriceGap(ltp, closePrice);

  return (
    <PlusMinusColoredValue
      className={`${classes.root} PriceDiffrenceBetween`}
      value={diffrence}
    >
      {getSymbolBasedOnvalue(diffrence)}
      {Math.abs(diffrence.toFixed(2))}
    </PlusMinusColoredValue>
  );
};

export default PriceDiffrenceBetween;
